import Notifications from "../../../api/notifications/notifications"
import LoadingState from "../../../consts/LoadingState"
// initial state
const state = () => ({  
	notifications: [
		{
			color: "grey",
			icon: "hourglass-half",
			message:
        "Loading notifications...",
			resourceID: "",
			seen: 1,
			sent: Date.now(),
		},
	],
})

const getters = {
	getNotifications: (state) => {
		return state.notifications
	},
	unread: (state) => {
		return state.notifications.filter((t) => t.seen != 1 && !t.divider).length
	},
}

// actions
const actions = {
	markAsRead({ commit, dispatch }, { index, id }) {
		Notifications.markAsRead(id).catch((err) => {
			dispatch("loading/" + LoadingState.ACTION_SET_ERROR, err, {
				root: true,
			})
		})
		commit("markAsRead", { index })
	},
	markAllAsRead({ commit, dispatch }) {
		//Send api request
		Notifications.markAllAsRead().catch((err) => {
			dispatch("loading/" + LoadingState.ACTION_SET_ERROR, err, { root: true })
		})
		commit("markAllAsRead")
	},
	deleteNotification({ commit, dispatch }, { index, id }) {
		commit("deleteNotification", { index })
		//Send api request
		Notifications.deleteNotification(id).catch((err) => {
			dispatch("loading/" + LoadingState.ACTION_SET_ERROR, err, {
				root: true,
			})
		})
	},
	deleteAllNotifications({commit, dispatch}) {
		commit("setNotifications", { notifications : [] })

		Notifications.deleteAllNotifications().catch((err) => {
			dispatch("loading/" + LoadingState.ACTION_SET_ERROR, err, {
				root: true,
			})
		})
	},
	loadNotifications({ commit, dispatch }, {offset, limit}) {
		dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, {
			root: true,
		})
		//Get notifications from api
		Notifications.list({offset, limit})
			.then((list) => {
				let notifications = []
				for (let item of list.items) {
					notifications.push(item)
					notifications.push({
						divider: true,
						inset: true,
					})
				}
				commit("setNotifications", { notifications })
				dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, {
					root: true,
				})
			})
			.catch((err) => {
				dispatch("loading/" + LoadingState.ACTION_SET_ERROR, err, {
					root: true,
				})
			})
	},
}

// mutations
const mutations = {
	markAllAsRead(state) {
		for (let notif of state.notifications) {
			notif.seen = 1
		}
	},
	deleteNotification(state, { index }) {
		state.notifications.splice(index, 2)
	},
	setNotifications(state, { notifications }) {
		state.notifications = notifications
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
}
